import API from '../../../constants/api';

export const FETCH_BANK_ENTRIES_REQUEST = '@@bankEntries/FETCH_BANK_ENTRIES_REQUEST';
export const FETCH_BANK_ENTRIES_SUCCESS = '@@bankEntries/FETCH_BANK_ENTRIES_SUCCESS';
export const FETCH_BANK_ENTRIES_FAILURE = '@@bankEntries/FETCH_BANK_ENTRIES_FAILURE';
export const CLEAR_BANK_ENTRIES = '@@bankEntries/CLEAR_BANK_ENTRIES';

export const fetchBankEntries = (filters = {}, page = 0, size = 10) => ({
    type: FETCH_BANK_ENTRIES_REQUEST,
    api: API.BANK_ENTRIES.LIST,
    filters,
    page,
    size,
});

export const clearBankEntries = () => ({ type: CLEAR_BANK_ENTRIES });
